import { ShieldCheck, Ban, FlaskConical } from "lucide-react";

interface USPStripProps {
  variant?: "light" | "dark";
}

const USPStrip = ({ variant = "dark" }: USPStripProps) => {
  const isLight = variant === "light";
  
  const usps = [
    {
      icon: ShieldCheck,
      text: "100% פרופילים מאומתים",
    },
    {
      icon: Ban,
      text: "אפס סווייפים",
    },
    {
      icon: FlaskConical,
      text: "התאמה מבוססת נתונים",
    },
  ];

  return (
    <section className={`py-6 md:py-8 ${isLight ? "bg-cream-dark" : "bg-navy-light"}`}>
      <div className="container mx-auto px-6">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          {usps.map((usp, index) => (
            <div key={index} className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                isLight ? "bg-gold/20" : "bg-gold/20"
              }`}>
                <usp.icon className="w-5 h-5 text-gold" />
              </div>
              <span className={`font-semibold text-sm md:text-base ${
                isLight ? "text-navy" : "text-cream"
              }`}>
                {usp.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USPStrip;